import {
  createQuestionSchemaWithMixins,
  questionHasComment,
  questionHasTimer,
  questionImage,
  questionInstantStatistic,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './MarkupAreaPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionHasComment,
    questionHasTimer,
    questionImage,
    questionRequiresAnswer,
    questionInstantStatistic,
  },
  type: config.name,
});
